export default __webpack_public_path__ + "static/media/WM-FL_2020_seemore03_NA-S106FX1_VN_201012-vn.e46421ec.jpg";